<!--
 * @Description: 自定义表格最新版
 * @version: 1.0.0
 * @Author: Monkey
 * @Date: 2025-07-04 09:02:03
 * @LastEditors: Monkey
 * @LastEditTime: 2025-08-08 00:10:45
-->
<template>
  <!-- 模板部分保持不变 -->
  <div class="scTable alljoins-table" :class="hideBottomIcon ? '' : 'alljoins-table-hasBottomIcon'"
    :style="{ 'height': _height }" ref="scTableMain" v-loading="loading">
    <div class="scTable-table" :style="{ 'height': _table_height }">

      <table-top-time-selector @change="handleTimeChange" />

      <!-- 原始表格 -->
      <el-table v-bind="$attrs" :data="tableData" :row-key="rowKey" :key="toggleIndex" ref="scTable"
        :height="height == 'auto' ? null : '100%'" :size="tableConfig.size" :border="tableConfig.border"
        :stripe="tableConfig.stripe"
        :summary-method="remoteSummary ? remoteSummaryMethod : (summaryConfig.fields ? customSummaryMethod : summaryMethod)"
        @sort-change="sortChange" @filter-change="filterChange" class="aj-table">

        <el-table-column v-if="isShowIndex" type="index" width="40" :fixed="ismobile ? false : 'left'" align="center"
          class-name="aj-table-column-index" />
        <el-table-column v-if="isSelection" type="selection" width="30" align="center" />

        <!-- 前置字段，有特殊定义的，不进行循环 -->
        <slot name="beforeColumn" />

        <template v-for="(item, index) in userColumn" :key="index">
          <el-table-column v-if="!item.hide" :column-key="item.prop" :label="item.label" :prop="item.prop"
            :width="item.width" :sortable="item.sortable" :fixed="item.fixed" :filters="item.filters"
            :align="item.align === undefined ? '' : item.align"
            :filter-method="remoteFilter || !item.filters ? null : filterHandler"
            :formatter="(row, col) => { return columnFormat(row, col, item.formatter) }"
            :class-name="item.className === undefined ? '' : item.className"
            :show-overflow-tooltip="item.showOverflowTooltip">
            <template v-if="item.customSlot" #default="scope">
              <slot :name="item.customSlot" :row="scope.row" />
            </template>
            <!-- 处理 tag 类型 -->
            <template v-else-if="item.template?.type === 'tag'" #default="scope">
              <el-tag :type="getTemplateAttrValue(item.template, 'type', scope.row) || 'info'"
                :closable="getTemplateAttrValue(item.template, 'closable', scope.row)"
                :disable-transitions="getTemplateAttrValue(item.template, 'disableTransitions', scope.row)"
                :hit="getTemplateAttrValue(item.template, 'hit', scope.row)"
                :color="getTemplateAttrValue(item.template, 'color', scope.row)"
                :size="getTemplateAttrValue(item.template, 'size', scope.row) || 'small'"
                :effect="getTemplateAttrValue(item.template, 'effect', scope.row) || 'light'"
                :round="getTemplateAttrValue(item.template, 'round', scope.row)" :class="item.client ? 'curpoint' : ''"
                @click="item.client && handleClientClick(item, scope.row)">
                {{ columnFormat(scope.row, scope.column, item.formatter) }}
              </el-tag>
            </template>
            <!-- 处理 switch 类型 -->
            <template v-else-if="item.template?.type === 'switch'" #default="scope">
              <el-switch v-model="scope.row[item.prop]"
                :loading="getTemplateAttrValue(item.template, 'loading', scope.row) || false"
                :active-value="item.template.attr?.activeValue" :inactive-value="item.template.attr?.inactiveValue"
                :size="getTemplateAttrValue(item.template, 'size', scope.row)"
                @change="(val) => item.template.function?.change ? item.template.function.change(scope.row[item.prop], scope.row, item) : null">
              </el-switch>
            </template>
            <!-- 处理 icon 类型 -->
            <template v-else-if="item.template?.type === 'icon'" #default="scope">
              <div style="display: flex; align-items: center;">
                <el-icon v-for="(attrValue, attrName) in item.template.attr" :key="attrName"
                  :class="item.client ? 'curpoint' : ''" @click="item.client && handleClientClick(item, scope.row)"
                  style="margin-bottom: 0">
                  <component :is="typeof attrValue === 'function' ? attrValue(scope.row) : attrValue"
                    v-if="attrName === 'type'" />
                </el-icon>
                <span v-if="item.formatter" style="margin-left: 2px">{{ columnFormat(scope.row, scope.column,
                  item.formatter) }}</span>
              </div>
            </template>
            <!-- 处理点击事件 -->
            <template v-else-if="item.client" #default="scope">
              <span class="client-cell curpoint" @click="handleClientClick(item, scope.row)">
                {{ columnFormat(scope.row, scope.column, item.formatter) }}
              </span>
            </template>
          </el-table-column>
        </template>

        <slot></slot>

        <el-table-column min-width="1"></el-table-column>

        <template #empty>
          <el-empty :description="emptyText" :image-size="100"></el-empty>
        </template>
      </el-table>
    </div>

    <!-- 底部分页 -->
    <div class="scTable-page scTable-page-icon" v-if="!hideBottomIcon">
      <table-icon-row v-if="!hideBottomIcon" ref="tableIconRowRef" :columns="tableColumns"
        :icon-config="processedIconConfig" :table-scroll-left="tableScrollLeft" @icon-click="handleIconClick" />
    </div>
    <div class="scTable-page" v-if="!hidePagination || !hideDo">
      <div class="scTable-pagination">
        <el-pagination v-if="!hidePagination" background size="small" :layout="paginationLayout" :total="total"
          :page-size="scPageSize" :page-sizes="pageSizes" v-model:currentPage="currentPage"
          @current-change="paginationChange" @update:page-size="pageSizeChange"></el-pagination>
      </div>
      <div class="scTable-do" v-if="!hideDo">
        <el-button v-if="!hideRefresh" @click="refresh" icon="el-icon-refresh" circle
          style="margin-left:15px"></el-button>
        <el-popover v-if="column" placement="top" title="列设置" :width="500" trigger="click" :hide-after="0"
          @show="customColumnShow = true" @after-leave="customColumnShow = false">
          <template #reference>
            <el-button icon="el-icon-set-up" circle style="margin-left:15px"></el-button>
          </template>
          <columnSetting v-if="customColumnShow" ref="columnSettingRef" @userChange="columnSettingChange"
            @save="columnSettingSave" @back="columnSettingBack" :column="userColumn"></columnSetting>
        </el-popover>
        <el-popover v-if="!hideSetting" placement="top" title="表格设置" :width="400" trigger="click" :hide-after="0">
          <template #reference>
            <el-button icon="el-icon-setting" circle style="margin-left:15px"></el-button>
          </template>
          <el-form label-width="80px" label-position="left">
            <el-form-item label="表格尺寸">
              <el-radio-group v-model="tableConfig.size" size="small" @change="configSizeChange">
                <el-radio-button value="large">大</el-radio-button>
                <el-radio-button value="default">正常</el-radio-button>
                <el-radio-button value="small">小</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="样式">
              <el-checkbox v-model="tableConfig.border" label="纵向边框" @change="configChange"></el-checkbox>
              <el-checkbox v-model="tableConfig.stripe" label="斑马纹" @change="configChange"></el-checkbox>
            </el-form-item>
          </el-form>
        </el-popover>
      </div>
    </div>

    <table-bottom-icon-chart-dialog v-if="tableBottomIconChartDialogVisible" ref="tableBottomIconChartDialogRef"
      @closed="tableBottomIconChartDialogVisible = false" />
  </div>
</template>

<script setup>
import { ref, reactive, computed, watch, onMounted, onActivated, onDeactivated, onBeforeUnmount, nextTick } from 'vue'
import config from "@/config/table"
import columnSetting from './columnSetting.vue'
import tableIconRow from './tableBottomIcon.vue'
import tableBottomIconChartDialog from './tableBottomIconChartDialog.vue'
import tableTopTimeSelector from './tableTopTimeSelector.vue'
import { useStore } from 'vuex'

import { generateChartOption } from './bottomIconChart'

const store = useStore()
const props = defineProps({
  tableName: { type: String, default: "" },
  apiObj: { type: Object, default: () => { } },
  params: { type: Object, default: () => ({}) },
  data: { type: Object, default: () => { } },
  height: { type: [String, Number], default: "100%" },
  size: { type: String, default: "default" },
  border: { type: Boolean, default: false },
  stripe: { type: Boolean, default: false },
  pageSize: { type: Number, default: config.pageSize },
  pageSizes: { type: Array, default: config.pageSizes },
  rowKey: { type: String, default: "" },
  summaryMethod: { type: Function, default: null },
  column: { type: Object, default: () => { } },
  remoteSort: { type: Boolean, default: true },
  remoteFilter: { type: Boolean, default: false },
  remoteSummary: { type: Boolean, default: false },
  isShowIndex: { type: Boolean, default: false },
  isSelection: { type: Boolean, default: false },
  hidePagination: { type: Boolean, default: false },
  hideDo: { type: Boolean, default: false },
  hideRefresh: { type: Boolean, default: false },
  hideSetting: { type: Boolean, default: false },
  hideBottomIcon: { type: Boolean, default: false }, // 新增属性：是否隐藏底部图标行
  bottomIconConfig: { type: Object, default: () => ({}) }, // 新增属性：底部图标配置，包含chart和icons属性，icons基于prop字段匹配列
  paginationLayout: { type: String, default: config.paginationLayout },
  dataFormat: { type: Function, default: () => { } },
  // 汇总参数
  summaryConfig: {
    type: Object,
    default: () => ({
      label: '汇总',
      fields: {},
      avgStyle: { color: '#1e88e5', backgroundColor: 'rgba(30, 136, 229, 0.08)' },
      sumStyle: { color: '#43a047', backgroundColor: 'rgba(67, 160, 71, 0.08)' }
    })
  }
})

const emit = defineEmits(['dataChange', 'iconClick'])

// 响应式引用
const scTableMain = ref(null)
const scTable = ref(null)
const columnSettingRef = ref(null)
const scPageSize = ref(props.pageSize)
const isActivat = ref(true)
const emptyText = ref("暂无数据")
const toggleIndex = ref(0)
const tableData = ref([])
const total = ref(0)
const currentPage = ref(1)
const prop = ref(null)
const order = ref(null)
const loading = ref(false)
const tableParams = reactive({ ...props.params })
const userColumn = ref([])
const customColumnShow = ref(false)
const summary = ref({})
const tableBottomIconChartDialogVisible = ref(false)
const tableBottomIconChartDialogRef = ref(null)

// 滚动同步相关
const tableIconRowRef = ref(null)
const tableScrollLeft = ref(0)
const scrollSyncEnabled = ref(true)

// 添加防重复调用机制
const isDataLoading = ref(false)
const pendingParams = ref(null)

// 配置对象
const tableConfig = reactive({
  size: props.size,
  border: props.border,
  stripe: props.stripe
})

// 计算属性
const ismobile = computed(() => store.state.global.ismobile)
const _height = computed(() => Number(props.height) ? `${Number(props.height)}px` : props.height)
const _table_height = computed(() => props.hidePagination && props.hideDo ? "100%" : props.hideBottomIcon ? "calc(100% - 50px)" : "calc(100% - 100px)")
// 存储真实列宽度的响应式变量
const realColumnWidths = ref([])
const resizeObserver = ref(null)

// 获取表格真实列宽度
const getRealColumnWidths = () => {
  if (!scTable.value) {
    console.warn('表格引用不存在')
    return []
  }

  try {
    const tableEl = scTable.value.$el
    if (!tableEl) {
      console.warn('表格DOM元素不存在')
      return []
    }

    // 等待DOM更新完成
    nextTick(() => {
      setTimeout(() => {
        try {
          // 方法1: 从表头获取实际渲染宽度（最可靠）
          const headerWrapper = tableEl.querySelector('.el-table__header-wrapper')
          if (headerWrapper) {
            const headerTable = headerWrapper.querySelector('table')
            if (headerTable) {
              const headerRow = headerTable.querySelector('thead tr')
              if (headerRow) {
                const headerCells = headerRow.querySelectorAll('th')
                if (headerCells.length > 0) {
                  const headerWidths = Array.from(headerCells).map(th => {
                    const rect = th.getBoundingClientRect()
                    return rect.width > 0 ? `${Math.round(rect.width)}px` : null
                  }).filter(w => w !== null)

                  if (headerWidths.length > 0) {
                    // console.log('从表头getBoundingClientRect获取到的宽度:', headerWidths)
                    realColumnWidths.value = headerWidths
                    return headerWidths
                  }
                }
              }
            }
          }

          // 方法2: 从colgroup获取
          const colgroup = tableEl.querySelector('colgroup')
          if (colgroup) {
            const cols = colgroup.querySelectorAll('col')
            const colgroupWidths = Array.from(cols).map(col => {
              const width = col.style.width || col.getAttribute('width')
              return width && width !== 'auto' && width !== '' ? width : null
            }).filter(w => w !== null)

            if (colgroupWidths.length > 0) {
              // console.log('从colgroup获取到的宽度:', colgroupWidths)
              realColumnWidths.value = colgroupWidths
              return colgroupWidths
            }
          }

          // 方法3: 从表体单元格获取实际渲染宽度
          const bodyWrapper = tableEl.querySelector('.el-table__body-wrapper')
          if (bodyWrapper) {
            const bodyTable = bodyWrapper.querySelector('table')
            if (bodyTable) {
              const bodyRow = bodyTable.querySelector('tbody tr')
              if (bodyRow) {
                const bodyCells = bodyRow.querySelectorAll('td')
                if (bodyCells.length > 0) {
                  const bodyWidths = Array.from(bodyCells).map(td => {
                    const rect = td.getBoundingClientRect()
                    return rect.width > 0 ? `${Math.round(rect.width)}px` : null
                  }).filter(w => w !== null)

                  if (bodyWidths.length > 0) {
                    console.log('从表体getBoundingClientRect获取到的宽度:', bodyWidths)
                    realColumnWidths.value = bodyWidths
                    return bodyWidths
                  }
                }
              }
            }
          }

          console.warn('无法获取表格真实列宽度，使用配置的宽度')
          realColumnWidths.value = []
        } catch (innerError) {
          console.warn('获取表格真实列宽度内部失败:', innerError)
          realColumnWidths.value = []
        }
      }, 50)
    })

    return realColumnWidths.value
  } catch (error) {
    console.warn('获取表格真实列宽度失败:', error)
    return []
  }
}

// 设置表格宽度监听器
const setupTableWidthObserver = () => {
  if (!scTable.value) return

  try {
    const tableEl = scTable.value.$el
    if (!tableEl) return

    // 清理之前的观察器
    if (resizeObserver.value) {
      resizeObserver.value.disconnect()
    }

    // 创建新的ResizeObserver
    resizeObserver.value = new ResizeObserver(() => {
      // 表格尺寸变化时重新获取列宽度
      setTimeout(() => {
        getRealColumnWidths()
      }, 100)
    })

    // 观察表格容器
    resizeObserver.value.observe(tableEl)

    // 观察表头容器
    const headerWrapper = tableEl.querySelector('.el-table__header-wrapper')
    if (headerWrapper) {
      resizeObserver.value.observe(headerWrapper)
    }

  } catch (error) {
    console.warn('设置表格宽度监听器失败:', error)
  }
}

// 底部图标列
const tableColumns = computed(() => {
  const columns = []
  const realWidths = realColumnWidths.value
  let columnIndex = 0

  // 添加索引列
  if (props.isShowIndex) {
    columns.push({
      label: 'Index',
      prop: '__index__',
      className: 'aj-table-column-index',
      align: 'center',
      width: realWidths[columnIndex] || '40px'
    })
    columnIndex++
  }

  // 添加选择列
  if (props.isSelection) {
    columns.push({
      label: 'Selection',
      prop: '__selection__',
      align: 'center',
      width: realWidths[columnIndex] || '30px'
    })
    columnIndex++
  }

  // 添加数据列
  props.column?.forEach(col => {
    if (!col.hide) {
      columns.push({
        ...col,
        align: col.align || 'center',
        width: realWidths[columnIndex] || col.width || col.minWidth || 'auto'
      })
      columnIndex++
    }
  })

  // 添加占位列
  columns.push({
    label: 'Placeholder',
    prop: '__placeholder__',
    width: realWidths[columnIndex] || 'auto'
  })

  return columns
})

// 处理基于prop的底部图标配置
const processedIconConfig = computed(() => {
  if (!props.bottomIconConfig || !props.bottomIconConfig.icons || props.bottomIconConfig.icons.length === 0) {
    return []
  }

  const columns = tableColumns.value
  const iconConfigArray = new Array(columns.length).fill(null)

  // 遍历用户配置的图标
  props.bottomIconConfig.icons.forEach(iconConfig => {
    if (!iconConfig || !iconConfig.prop) return

    // 查找对应的列索引
    const columnIndex = columns.findIndex(col => col.prop === iconConfig.prop)
    if (columnIndex !== -1) {
      iconConfigArray[columnIndex] = iconConfig
    }
  })

  return iconConfigArray
})


// 方法
const columnFormat = (row, column, method) => {
  if (typeof method === 'string') return method
  if (typeof method === 'function') return method(row, column)
  return row[column.property]
}

// 获取列设置
const getCustomColumn = async () => {
  if (!props.column) return
  const userCols = await config.columnSettingGet(props.tableName, props.column)
  if (userCols.length > 0) {
    userColumn.value = userCols
  }
}

// 获取配置
const getCustomConfig = async () => {
  const userCfg = await config.configSettingGet(props.tableName, tableConfig)
  Object.assign(tableConfig, userCfg)
}

// 强制更新tableColumns以获取真实列宽度
const forceUpdateTableColumns = () => {
  // 重新获取列宽度
  getRealColumnWidths()
  // 触发tableColumns重新计算
  toggleIndex.value += 1
}

// 获取数据
const getData = async (params = {}) => {
  if (isDataLoading.value) {
    pendingParams.value = params
    return
  }
  isDataLoading.value = true

  try {
    loading.value = true
    const reqData = {
      [config.request.page]: currentPage.value,
      [config.request.pageSize]: scPageSize.value,
      [config.request.prop]: prop.value,
      [config.request.order]: order.value
    }

    tableParams.page = currentPage.value
    tableParams.pageSize = scPageSize.value

    if (props.hidePagination) {
      delete reqData[config.request.page]
      delete reqData[config.request.pageSize]
    }

    Object.assign(reqData, tableParams)

    try {
      const res = await props.apiObj.get(reqData)
      const response = config.parseData(res)

      if (response.code !== config.successCode) {
        emptyText.value = response.msg
        loading.value = false
        return
      }

      emptyText.value = "暂无数据"

      if (props.hidePagination) {
        tableData.value = response.data || []
      } else {
        tableData.value = response.rows || []
        total.value = response.total || 0
      }

      summary.value = response.summary || {}
      emit('dataChange', res, tableData.value)
    } catch (error) {
      emptyText.value = error?.statusText || "请求错误"
    } finally {
      loading.value = false
      nextTick(() => {
        scTable.value?.setScrollTop(0)
        // 在表格渲染完成后更新列宽度信息
        setTimeout(() => {
          setupTableWidthObserver()
          forceUpdateTableColumns()
          // 延迟更长时间确保DOM完全渲染
          setTimeout(() => {
            setupTableScrollListener()
          }, 500)
        }, 200)
      })
    }
  } finally {
    isDataLoading.value = false
    // 处理待处理的参数
    if (pendingParams.value) {
      const nextParams = pendingParams.value
      pendingParams.value = null
      getData(nextParams)
    }
  }
}

// 分页变化
const paginationChange = () => getData()

// 每页条数变化
const pageSizeChange = (size) => {
  scPageSize.value = size
  getData()
}

// 刷新数据
const refresh = () => {
  scTable.value?.clearSelection()
  getData()
}

// 更新数据
const upData = (params, page = 1) => {
  currentPage.value = page
  scTable.value?.clearSelection()
  Object.assign(tableParams, params || {})
  if (params?.pageSize) scPageSize.value = params.pageSize
  getData()
}

// 重载数据
const reload = (params, page = 1) => {
  currentPage.value = page
  Object.keys(tableParams).forEach(key => delete tableParams[key])
  Object.assign(tableParams, params || {})
  scTable.value?.clearSelection()
  scTable.value?.clearSort()
  scTable.value?.clearFilter()
  getData()
}

// 列设置变化
const columnSettingChange = (newColumn) => {
  // 按照 newColumn 的顺序来合并，保持用户拖拽后的排序
  const mergedColumns = newColumn.map(newCol => {
    const originalCol = props.column.find(col => col.prop === newCol.prop)
    return originalCol ? {
      ...newCol,
      formatter: originalCol.formatter,
      client: originalCol.client,
      template: originalCol.template,
      className: originalCol.className,
      showOverflowTooltip: originalCol.showOverflowTooltip,
      customSlot: originalCol.customSlot
    } : newCol
  })

  userColumn.value = mergedColumns
  toggleIndex.value += 1
}

// 保存列设置
const columnSettingSave = async (userColumn) => {
  columnSettingRef.value.isSave = true
  try {
    await config.columnSettingSave(props.tableName, userColumn)
    columnSettingRef.value.isSave = false
  } catch (error) {
    columnSettingRef.value.isSave = false
    throw new Error('保存失败')
  }
}

// 重置列设置
const columnSettingBack = async () => {
  columnSettingRef.value.isSave = true
  try {
    const cols = await config.columnSettingReset(props.tableName, props.column)
    userColumn.value = cols
    columnSettingRef.value.usercolumn = JSON.parse(JSON.stringify(userColumn.value))
    columnSettingRef.value.isSave = false
  } catch (error) {
    columnSettingRef.value.isSave = false
    throw new Error('重置失败')
  }
}

// 获取模板属性值
const getTemplateAttrValue = (template, attrName, row) => {
  if (template.attr && typeof template.attr[attrName] === 'function') {
    return template.attr[attrName](row)
  }
  if (template.function && typeof template.function === 'function') {
    return template.function(row)?.[attrName]
  }
  return template.attr?.[attrName]
}

// 排序变化
const sortChange = (obj) => {
  if (!props.remoteSort) return
  prop.value = obj.prop
  order.value = obj.order
  getData()
}

// 过滤处理
const filterHandler = (value, row, column) => {
  const property = column.property
  return row[property] === value
}

// 过滤变化
const filterChange = (filters) => {
  if (!props.remoteFilter) return
  const filterParams = {}
  Object.keys(filters).forEach(key => {
    filterParams[key] = filters[key].join(',')
  })
  upData(filterParams)
}

// 远程汇总方法
const remoteSummaryMethod = (param) => {
  const { columns } = param
  const sums = []
  columns.forEach((column, index) => {
    if (index === 0) {
      sums[index] = '合计'
      return
    }
    sums[index] = summary.value[column.property] || ''
  })
  return sums
}

// 配置变化
const configSizeChange = () => {
  scTable.value?.doLayout()
  configChange()
}

const configChange = () => {
  config.configSettingSave(props.tableName, tableConfig)
}

// 滚动同步相关函数
const setupTableScrollListener = () => {
  if (!scTable.value || !scrollSyncEnabled.value) {
    return
  }

  const tableEl = scTable.value.$el
  if (!tableEl) {
    return
  }

  // 查找所有可能的滚动容器
  const scrollContainers = [
    '.el-table__body-wrapper',
    '.el-scrollbar__wrap',
    '.el-table__fixed-body-wrapper',
    '.el-scrollbar__view'
  ]

  let foundScrollContainer = false

  // 尝试绑定到所有可能的滚动容器
  scrollContainers.forEach(selector => {
    const container = tableEl.querySelector(selector)
    if (container) {
      // 清理之前的监听器
      container.removeEventListener('scroll', handleTableScroll)
      // 添加滚动监听器
      container.addEventListener('scroll', handleTableScroll, { passive: true })
      foundScrollContainer = true
    }
  })

  // 如果找到了滚动容器，直接返回
  if (foundScrollContainer) {
    return
  }

  // 使用MutationObserver等待表格完全渲染
  const observer = new MutationObserver((mutations, obs) => {
    let foundContainer = false

    // 尝试查找所有可能的滚动容器
    scrollContainers.forEach(selector => {
      const container = tableEl.querySelector(selector)
      if (container && !foundContainer) {
        // 清理之前的监听器
        container.removeEventListener('scroll', handleTableScroll)
        // 添加滚动监听器
        container.addEventListener('scroll', handleTableScroll, { passive: true })

        foundContainer = true
        // 停止观察
        obs.disconnect()
      }
    })
  })

  // 开始观察DOM变化
  observer.observe(tableEl, {
    childList: true,
    subtree: true
  })

  // 设置超时，避免无限等待
  setTimeout(() => {
    observer.disconnect()

    // 如果超时后仍未找到，尝试直接查找所有可能的滚动容器
    let timeoutFoundContainer = false

    scrollContainers.forEach(selector => {
      const container = tableEl.querySelector(selector)
      if (container && !timeoutFoundContainer) {
        container.removeEventListener('scroll', handleTableScroll)
        container.addEventListener('scroll', handleTableScroll, { passive: true })
        timeoutFoundContainer = true
      }
    })

    if (!timeoutFoundContainer) {
      // 尝试监听表格元素本身
      if (tableEl.scrollWidth > tableEl.clientWidth) {
        tableEl.removeEventListener('scroll', handleTableScroll)
        tableEl.addEventListener('scroll', handleTableScroll, { passive: true })
      }
    }
  }, 3000)
}

const handleTableScroll = (event) => {
  if (!scrollSyncEnabled.value) {
    return
  }

  const scrollLeft = event.target.scrollLeft
  tableScrollLeft.value = scrollLeft

  // 同步底部图标行的滚动位置
  if (tableIconRowRef.value && tableIconRowRef.value.syncScroll) {
    tableIconRowRef.value.syncScroll()
  }
}

const cleanupScrollListener = () => {
  if (!scTable.value) {
    return
  }

  try {
    const tableEl = scTable.value.$el
    if (!tableEl) {
      return
    }

    // 清理所有可能的滚动容器的监听器
    const scrollContainers = [
      '.el-table__body-wrapper',
      '.el-scrollbar__wrap',
      '.el-table__fixed-body-wrapper',
      '.el-scrollbar__view'
    ]

    scrollContainers.forEach(selector => {
      const container = tableEl.querySelector(selector)
      if (container) {
        container.removeEventListener('scroll', handleTableScroll)
      }
    })

    // 也清理表格元素本身的监听器
    tableEl.removeEventListener('scroll', handleTableScroll)
  } catch (error) {
    console.warn('清理表格滚动监听器失败:', error)
  }
}

// 行操作方法
const unshiftRow = (row) => tableData.value.unshift(row)
const pushRow = (row) => tableData.value.push(row)

const updateKey = (row, rowKey = props.rowKey) => {
  tableData.value.filter(item => item[rowKey] === row[rowKey])
    .forEach(item => Object.assign(item, row))
}

const updateIndex = (row, index) => {
  Object.assign(tableData.value[index], row)
}

const removeIndex = (index) => {
  tableData.value.splice(index, 1)
}

const removeIndexes = (indexes = []) => {
  indexes.forEach(index => removeIndex(index))
}

const removeKey = (key, rowKey = props.rowKey) => {
  const index = tableData.value.findIndex(item => item[rowKey] === key)
  if (index !== -1) removeIndex(index)
}

const removeKeys = (keys = [], rowKey = props.rowKey) => {
  keys.forEach(key => removeKey(key, rowKey))
}

// 单元格点击
const handleClientClick = (column, row) => {
  if (column.client && typeof column.client === 'function') {
    column.client(row)
  }
}

// 处理图标点击事件
const handleIconClick = (event) => {
  const { iconConfig, column, index } = event
  // 触发事件给父组件
  emit('iconClick', {
    column,
    index,
    config: iconConfig
  })

  // 如果配置中有onClick方法，直接调用
  if (iconConfig?.onClick) {
    iconConfig.onClick(column, index)
  }

  if (iconConfig?.chart) {
    const option = generateChartOption(iconConfig, column, tableData.value, props.bottomIconConfig)
    if (option) {
      // console.log(option)
      tableBottomIconChartDialogVisible.value = true
      nextTick(() => {
        tableBottomIconChartDialogRef.value.open(option)
      })
    }
  }
}

// 顶部时间选择更改
const handleTimeChange = (time) => {
  const changeParams = { ...props.params }
  // console.log(time, changeParams)
  if (changeParams !== undefined) {
    if (time.type === 'custom') {
      // 自定义查询
      changeParams.searchParam.startDate = time.startDate
      changeParams.searchParam.endDate = time.endDate
      delete changeParams.searchParam.date
      delete changeParams.searchParam.dataGranularity
    } else {
      // 固定查询
      changeParams.searchParam.date = time.date
      changeParams.searchParam.dataGranularity = time.dataGranularity
      delete changeParams.searchParam.startDate
      delete changeParams.searchParam.endDate
    }
    upData(changeParams)
  }
}
// 添加自定义汇总方法
const customSummaryMethod = ({ columns, data }) => {
  const { fields, label } = props.summaryConfig;
  if (!fields || Object.keys(fields).length === 0 || !data || data.length === 0) {
    return [];
  }

  const sums = [];
  const stats = {};

  // 获取列配置
  const columnConfigs = props.column || [];

  // 初始化统计对象
  Object.keys(fields).forEach(field => {
    stats[field] = {
      type: fields[field],
      total: 0,
      count: 0,
      currency: null // 存储货币符号（如¥）
    };
  });

  // 计算统计值
  data.forEach(row => {
    Object.keys(stats).forEach(field => {
      // 查找字段对应的列配置
      const columnConfig = columnConfigs.find(col => col.prop === field);

      let rawValue; // 原始值（可能是数字或字符串）

      if (columnConfig && columnConfig.formatter) {
        // 如果字段有formatter，使用formatter计算结果
        try {
          rawValue = columnConfig.formatter(row);
        } catch (e) {
          console.error(`Error formatting value for ${field}:`, e);
          rawValue = 0;
        }
      } else {
        // 否则直接读取行数据
        rawValue = row[field];
      }

      // 解析值：处理数字和货币字符串（核心优化点）
      let numericValue = 0;
      if (typeof rawValue === 'number') {
        numericValue = rawValue;
      } else if (typeof rawValue === 'string') {
        // 尝试解析货币字符串（如"¥1,200.00"）
        const currencyMatch = rawValue.match(/^([^0-9-]*)(-?[\d,.]+)/); // 调整正则，支持包含逗号的数字
        if (currencyMatch) {
          // 提取数字部分并移除千分位逗号（关键修复）
          const numberStr = currencyMatch[2].replace(/,/g, ''); // 移除所有逗号，如"1,200"→"1200"
          numericValue = parseFloat(numberStr) || 0;

          // 如果是首次遇到货币符号，记录下来
          if (currencyMatch[1] && !stats[field].currency) {
            stats[field].currency = currencyMatch[1];
          }
        } else {
          // 普通数字字符串（无货币符号）
          numericValue = parseFloat(rawValue.replace(/,/g, '')) || 0; // 同样处理可能的逗号
        }
      }

      // 累加统计值
      stats[field].total += numericValue;
      stats[field].count += 1;
    });
  });

  // 构建汇总行
  columns.forEach((column, index) => {
    if (index === 0) {
      sums[index] = label || '汇总';
      return;
    }

    const prop = column.property;
    if (stats[prop]) {
      const { type, total, count, currency } = stats[prop];
      let value = '';

      if (type === 'avg' && count > 0) {
        value = (total / count).toFixed(2);
      } else if (type === 'sum') {
        value = total.toFixed(2);
      }

      // 添加货币符号（如果存在）
      sums[index] = currency ? `${currency}${value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}` : value;
    } else {
      sums[index] = '';
    }
  });

  return sums;
};

// 原生方法转发
const clearSelection = () => scTable.value?.clearSelection()
const toggleRowSelection = (row, selected) => scTable.value?.toggleRowSelection(row, selected)
const toggleAllSelection = () => scTable.value?.toggleAllSelection()
const toggleRowExpansion = (row, expanded) => scTable.value?.toggleRowExpansion(row, expanded)
const setCurrentRow = (row) => scTable.value?.setCurrentRow(row)
const clearSort = () => scTable.value?.clearSort()
const clearFilter = (columnKey) => scTable.value?.clearFilter(columnKey)
const doLayout = () => {
  scTable.value?.doLayout()
  // 布局变化后更新列宽度
  setTimeout(() => {
    setupTableWidthObserver()
    forceUpdateTableColumns()
  }, 100)
}
const sort = (propVal, orderVal) => scTable.value?.sort(propVal, orderVal)

// 监听器
watch(() => props.data, (newData) => {
  tableData.value = newData
  total.value = newData.length
})

watch(() => props.apiObj, () => {
  Object.assign(tableParams, props.params)
  refresh()
}, { deep: true })

watch(() => props.column, (newColumn) => {
  userColumn.value = newColumn
}, { deep: true })

// 监听滚动同步开关变化
watch(scrollSyncEnabled, (newVal) => {
  if (newVal) {
    nextTick(() => {
      setupTableScrollListener()
    })
  } else {
    cleanupScrollListener()
  }
})

// 生命周期钩子


onMounted(() => {
  getCustomColumn()
  getCustomConfig()

  if (props.apiObj?.url) {
    getData()
  } else if (props.data) {
    tableData.value = props.data
    total.value = props.data.length
    // 静态数据也需要更新列宽度
    nextTick(() => {
      setTimeout(() => {
        setupTableWidthObserver()
        forceUpdateTableColumns()
        // 延迟更长时间确保DOM完全渲染
        setTimeout(() => {
          setupTableScrollListener()
        }, 500)
      }, 300)
    })
  }
})

onActivated(() => {
  if (!isActivat.value) {
    scTable.value?.doLayout()
    setTimeout(() => {
      setupTableWidthObserver()
      forceUpdateTableColumns()
      // 延迟更长时间确保DOM完全渲染
      setTimeout(() => {
        setupTableScrollListener()
      }, 500)
    }, 100)
  }
})

onDeactivated(() => {
  isActivat.value = false
  // 清理ResizeObserver
  if (resizeObserver.value) {
    resizeObserver.value.disconnect()
    resizeObserver.value = null
  }
  // 清理滚动监听器
  cleanupScrollListener()
})

onBeforeUnmount(() => {
  // 组件销毁前清理ResizeObserver
  if (resizeObserver.value) {
    resizeObserver.value.disconnect()
    resizeObserver.value = null
  }
  // 清理滚动监听器
  cleanupScrollListener()
})

// 暴露方法给父组件
defineExpose({
  refresh,
  upData,
  reload,
  unshiftRow,
  pushRow,
  updateKey,
  updateIndex,
  removeIndex,
  removeIndexes,
  removeKey,
  removeKeys,
  clearSelection,
  toggleRowSelection,
  toggleAllSelection,
  toggleRowExpansion,
  setCurrentRow,
  clearSort,
  clearFilter,
  doLayout,
  sort
})
</script>

<style lang="scss" scoped>
/* 样式保持不变 */
.scTable-table {
  height: calc(100% - 50px);
}

.alljoins-table {
  position: relative;
}

.alljoins-table .aj-table {
  height: calc(100% - 60px) !important;
}

.client-cell {
  cursor: pointer;
  color: var(--el-color-primary);
  transition: color 0.3s;

  &:hover {
    color: var(--el-color-primary-light-3);
    text-decoration: underline;
  }

  &:active {
    color: var(--el-color-primary-dark-2);
  }
}

.scTable-page {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
}

.scTable-page.scTable-page-icon {
  padding: 0;
}

.scTable-do {
  white-space: nowrap;
}

.scTable:deep(.el-table__footer) .cell {
  font-weight: bold;
}

.scTable:deep(.el-table__body-wrapper) .el-scrollbar__bar.is-horizontal {
  height: 12px;
  border-radius: 12px;
}

.scTable:deep(.el-table__body-wrapper) .el-scrollbar__bar.is-vertical {
  width: 12px;
  border-radius: 12px;
}
</style>